import { Flex, Heading, IconButton } from '@chakra-ui/react';
import { Filters, MenuItem } from 'components/listing';
import React, { FC } from 'react';

import { CloseIcon } from '@chakra-ui/icons';
import { useIntlFormat } from 'hooks/useIntlFormat';
import { IPizza } from 'misc/interfaces';
import Link from 'next/link';

interface Props {
  onOpen: () => void;
  pizzas: Array<IPizza>;
}

export const MenuFull: FC<Props> = ({ onOpen, pizzas }) => {
  const [intlFormatter] = useIntlFormat();
  return (
    <>
      <Flex
        direction={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Heading as="h1" size="xl" my={4}>
          Toutes nos pizzas
        </Heading>
        <Link href={'/'} passHref>
          <IconButton
            aria-label="Close pizza"
            icon={<CloseIcon />}
            variant="outline"
            bgColor={'white'}
          />
        </Link>
      </Flex>

      <Flex wrap={'wrap'} justifyContent={'space-between'}>
        <Filters openDrawer={onOpen} />
        {pizzas.map((pizza) => {
          const detail = intlFormatter.format(pizza.ingredients);
          return (
            <MenuItem
              key={pizza.name}
              id={pizza.id}
              image={pizza.photos[0].url}
              name={pizza.name}
              alt="Veggie"
              detail={detail}
              price={pizza.prices[0]}
              url={`/pizza/${pizza.slug}`}
            />
          );
        })}
      </Flex>
    </>
  );
};
